import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
import { BodySilhouette, TreeOfLife } from './BioDecor';
const points: {
  problem: string;
  result: string;
}[] = [{
  problem: 'Llego sin protocolo claro',
  result: 'Improviso preguntas sin sistema que me respalde'
}, {
  problem: 'No sé identificar el conflicto biológico rápido',
  result: 'Pierdo los primeros minutos críticos por dudas'
}, {
  problem: 'No tengo rituales para cerrar',
  result: 'El paciente se va “abierto” y la integración no ocurre'
}, {
  problem: 'Trabajo sin protección legal',
  result: 'Riesgo legal que no veo venir'
}, {
  problem: 'No sé cómo hacer seguimiento',
  result: 'Cada sesión es un empezar de cero, sin continuidad'
}, {
  problem: 'Me dreno emocionalmente sin saber por qué',
  result: 'Absorbo la energía del paciente sin protección'
}, {
  problem: 'No puedo cobrar lo que valgo',
  result: 'Vendo sesiones, no sistemas. Siempre gano poco'
}, {
  problem: 'Pierdo pacientes',
  result: 'No explico bien el valor ni la estructura'
}];
export function PainPoints() {
  return <Section className="max-w-5xl" data-id="element-270" data-mp="1u23sssyr9bsd">
      <div className="relative overflow-hidden rounded-3xl border border-brand-blue/25 bg-brand-blueMist/60 p-6 md:p-10" data-id="element-271" data-mp="1u12emfmg096f">
        <BodySilhouette className="pointer-events-none absolute -right-4 -top-6 h-56 w-28 text-brand-blue/15" data-id="element-272" data-mp="27v32gebuwbs0" />
        <div className="relative" data-id="element-273" data-mp="1g1syth25fh2z">
          <h2 className="mb-8 text-center font-display text-2xl font-bold text-brand-blue md:text-4xl" data-id="element-274" data-mp="1g114sao79ret">
            ❌ LO QUE PASA SIN EL KIT MAESTRO
          </h2>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-275" data-mp="1p2hcubrjlhfv">
            {points.map(point => <li key={point.problem} className="rounded-xl border-l-4 border-brand-blueMid bg-white p-5" data-id="element-276" data-mp="1p04nhdjgg4ss">
                <p className="mb-1.5 flex items-start gap-2 text-sm font-bold text-brand-blue" data-id="element-277" data-mp="30hnw5lft0zyq">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-goldDark" data-id="element-278" data-mp="2vil20w1d4e5j" />
                  {point.problem}
                </p>
                <p className="pl-6 text-sm leading-relaxed text-brand-muted" data-id="element-279" data-mp="1t5ycev8y0x7r">→ {point.result}</p>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="relative mt-12 overflow-hidden rounded-3xl border border-brand-gold/40 bg-brand-parchment p-8 text-center md:p-12" data-id="element-280" data-mp="225tnz16euu8b">
        <TreeOfLife className="pointer-events-none absolute -bottom-10 -left-6 h-48 w-28 text-brand-greenSoft/20" data-id="element-281" data-mp="273v8lqjhj1lw" />
        <div className="relative" data-id="element-282" data-mp="1ag8hm856kbfu">
          <h3 className="font-display text-2xl font-bold leading-tight text-brand-blue md:text-4xl" data-id="element-283" data-mp="1eg8sxjwzg6io">
            ¿Y si esta fuera la última sesión que trabajás sin sistema?
          </h3>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-284" data-mp="1jdirbp2cnsin">
            Imaginá que la próxima sesión comienza con claridad total. Identificás el conflicto en 10 minutos. Aplicás
            el protocolo exacto. Prescribís un ritual. El paciente se va transformado. Sin dudas. Sin improvisación.
            Con resultados reales.
          </p>
        </div>
      </div>
    </Section>;
}